import analyticsModule from '../../../library/analytics/index'
import { ANALYTICS_EVENTS, ANALYTICS_FIELDS } from '../../../library/analytics/constants'

export const trackFileUpload = ({ size, name }, eventName = ANALYTICS_EVENTS.fileUpload) => {
  // Rounding result to two decimals
  const sizeInMB = (size * (10 ** -6)).toFixed(2)
  analyticsModule.getMixpanelInstance().track(eventName, {
    [ANALYTICS_FIELDS.type]: name.split('.').pop(), // get extension
    // The conversion of 1 kB into megabytes results in 0.00, so for those cases we are showing that the size is 1 kB or less
    [`${ANALYTICS_FIELDS.size} in MB`]: Number(sizeInMB) === 0 ? '1 kB or less' : sizeInMB
  })
}
